





























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PageBanner from '@/components/PageBanner.vue';
import { HOST } from '@/global';
import { Action } from 'vuex-class';
import { FETCHNEWSCATEGORY, FETCH_CHILDREN } from '@/store/actions.names';

import { FetchChildrenParams } from '@/store/store.types';
import { NewsPage } from '@/store/cms.types';
import InfiniteLoading from 'vue-infinite-loading';

@Component({
  name: 'NewsIndexPage',
  components: {
    PageBanner,
    InfiniteLoading,
  },
})
export default class NewsIndexPage extends Vue {
  @Prop() pageData: any;
  HOST = HOST;

  @Action(FETCH_CHILDREN) fetchNews: any;
  @Action(FETCHNEWSCATEGORY) fetchNewsCategory: any;
  news: Array<NewsPage> = [];
  queryData: any = {
    activeTab: null,
    searchQuery: '',
  };
  loadLock: boolean = false;
  count: number | null = null;
  paginationData: any = {
    limit: 12,
    offset: 0,
  };

  loadMore($state: any) {
    // console.log('scroll');
    this.paginationData.offset += this.paginationData.limit;
    if (this.count != null && this.paginationData.offset >= this.count) {
      console.log('complete', this.count, this.paginationData.offset);
      $state.complete();
    } else {
      // console.log('newssss', this.news);
      this.fetchPosts(
        this.queryParams(this.queryData, this.paginationData),
        true
      ).then(() => {
        $state.loaded();
      });
    }
  }

  updateTab(evt: number | null) {
    this.paginationData.offset = 0;
    this.queryData.activeTab = evt;
  }

  updateSearchQuery(evt: string) {
    this.paginationData.offset = 0;
    this.queryData.searchQuery = evt;
  }

  resetInput() {
    (this.$refs['search'] as any).value = '';
    this.queryData.searchQuery = '';
  }

  get showcase() {
    if (this.queryData.activeTab == null) {
      return this.pageData.showcase_news_list[0];
    }
    if (this.queryData.activeTab == !null) {
      return null;
    }
    // else {
    //   const data = this.pageData.showcase_news_list.filter((val: any) => {
    //     return val.category == this.queryData.activeTab;
    //   });
    //   if (data.length > 0) {
    //     return data[0];
    //   } else {
    //     return null;
    //   }
    // }
  }

  queryParams(qdata: any, pagiData: any): any {
    const params: any = JSON.parse(JSON.stringify(pagiData));

    if (qdata.searchQuery.length > 0) {
      params.search = qdata.searchQuery.replace(' ', '+');
    } else {
      if (qdata.activeTab != null) {
        params.category = qdata.activeTab;
      }
    }
    // console.log(params);
    return params;
  }

  @Watch('queryData', { deep: true, immediate: true })
  handleQueryParamsChange(val: any, oldVal: any) {
    this.fetchPosts(this.queryParams(val, this.paginationData));
  }

  async fetchPosts(params: any, append = false) {
    const postData: FetchChildrenParams = {
      id: this.pageData.id,
      pageType: 'home.NewsPage',
      fields: 'title,short_description',
    };
    if (Object.keys(params).length > 0) {
      postData.params = params;
    }
    const oldNews = JSON.stringify(this.news);
    return new Promise((resolve: any) => {
      this.fetchNews(postData).then((data: any) => {
        this.count = data.meta.total_count;
        if (append) {
          this.$set(this, 'news', [...JSON.parse(oldNews), ...data.items]);
          // this.news = { ...JSON.parse(JSON.stringify(this.news)), ...data.items };
        } else {
          // console.log('nolock');
          this.$set(this, 'news', data.items);
        }

        resolve();
      });
    });
  }

  scroll_left() {
    let content: any = document.querySelector('.horizontal-nav');
    content.scrollLeft -= 100;
  }
  scroll_right() {
    let content: any = document.querySelector('.horizontal-nav');
    content.scrollLeft += 100;
  }

  get currenRoute() {
    return this.$route.path;
  }

  // get searchResultQuery() {
  //   if (this.queryData.searchQuery) {
  //     return this.news.filter((item: any) => {
  //       return this.queryData.searchQuery
  //         .toLowercase()
  //         .split(' ')
  //         .every((v: any) => item.title.toLowerCase().includes(v));
  //     });
  //   } else {
  //     return this.news;
  //   }
  // }
  mounted() {
    this.fetchNews(
      this.fetchPosts(this.queryParams(this.queryData, this.paginationData))
    );
  }
}
